import { Directive } from '@angular/core';

@Directive({
  selector: '[app-badge]',
  host: {
    class: 'absolute -right-0.5 -top-0.5 h-6 w-6 rounded-full text-center leading-5',
  },
})
export class BadgeDirective {}
